<template>
  <div id="app" class="w-screen h-screen">
    <component :is="layout">
      <router-view :layout.sync="layout" />
    <PhoneNumberModel  v-if="isPhoneNumberVisible" ref="phoneModal" :phoneNumber="phoneNumber" @close="handlePhoneNumberDialog"  />
    <ComposeMail v-if="isMailComposeVisible" ref="composeMail" :email="emailData" @close="handleMailComposeClose" />
    <CalenderEventSchedule v-if="isCalendarEventVisible" ref="calenderEventSchedule" :event="eventData" @close="handleCalendarEventClose" />
    <!-- <InternalChat v-if="getActiveWorkspace" /> -->
    </component>
    <!-- <internet-error v-else /> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// import InternetError from "./components/application/internetError.vue";
import ComposeMail from "./views/common/ComposeMail.vue";
import PhoneNumberModel from "./views/common/PhoneCallModal.vue";
import AppConfiguration from "./config/app";
import CalenderEventSchedule from "./views/common/CalenderEventSchedule.vue";
// import InternalChat from "./components/InternalChat.vue";
export default {
  name: "App",
  components: {
    // InternetError,
    ComposeMail,
    PhoneNumberModel,
    CalenderEventSchedule,
    // InternalChat
  },
  computed: {
    ...mapGetters("auth", ["getActiveWorkspace"]),
    ...mapGetters("company", ["getCompanyDetails"]),
  },
  data() {
    return {
      showErrorMessage: !navigator.onLine,
      layout: "div",
      online: true,
      isMailComposeVisible: false, // Visibility state for Mail Compose component
      isPhoneNumberVisible:false ,
      isCalendarEventVisible:false,
      phoneNumber:'',
      emailData:{},
      eventdata:{}
    };
  },
  metaInfo: {
    title: "fakeeh care group",
    titleTemplate: "%s | fakeeh care",
    htmlAttrs: {
      lang: "en-US",
    },
    link: [
      // { rel: 'stylesheet', href: '/css/index.css' },
      { rel: "favicon", href: "fakeehfavicon.png" },
    ],
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Fakeeh Care Group",
      },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        property: "og:title",
        content: "Fakeeh Care Group",
      },
      { property: "og:site_name", content: "Fakeeh Care Group" },
      { property: "og:type", content: "website" },
      { name: "robots", content: "index,follow" },
    ],
  },
  beforeMount() {},
  mounted() {
    this.appSettings = AppConfiguration;
    window.addEventListener("online", this.handleOnline);
    window.addEventListener("offline", this.handleOffline);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.handleOnline);
    window.removeEventListener("offline", this.handleOffline);
  },
  methods: {
    amIOnline(e) {
      this.online = e;
    },
    backToHome() {
      this.$router.go();
    },
    // handleOnline() {
    //   this.showErrorMessage = false;
    // },
    // handleOffline() {
    //   this.showErrorMessage = true;
    // },
    showMailCompose() {
      this.isMailComposeVisible = true;
    },
    handleMailComposeClose() {
      this.isMailComposeVisible = false;
    },
    showPhoneNumberDialog() {
      this.isPhoneNumberVisible = true;
    },
    handlePhoneNumberDialog() {
      this.isPhoneNumberVisible = false;
      this.phoneNumber="";
    },
    showCalendarEvent() {
      this.isCalendarEventVisible = true;
    },
    handleCalendarEventClose() {
      this.isCalendarEventVisible = false;
      this.eventdata={};
    },
  },
  created() {
  this.$eventBus.$on("show-phone-number", (data) => {
    console.log("Show Phone called",data)
    this.isPhoneNumberVisible = true;
    this.phoneNumber= data;
  });
  // this.$eventBus.$on("hide-phone-number", () => {
  //   this.isPhoneNumberVisible = false;
  //   this.phoneNumber= null;
  // });

  this.$eventBus.$on("showMailComposer", (data) => {
    console.log("Show mail called",data)
    this.isMailComposeVisible = true;
    this.emailData= data;
  });
  this.$eventBus.$on("hide-mail-compose", () => {
    this.isMailComposeVisible = false;
  });
  this.$eventBus.$on("showCalendarEvent", (data) => {
    console.log("Show Calender Event called",data)
    this.isCalendarEventVisible = true;
    this.eventData= data;
  });
  this.$eventBus.$on("hide-Calendar-Event", () => {
    this.isCalendarEventVisible = false;
  });
}
};
</script>
<style lang="scss">
* {
  margin: 0;
}
.offline {
  .division {
    text-align: center;
  }
  .para {
    font-size: 19px;
    font-weight: 300;
    color: rgb(0, 0, 0);
  }
  .heading {
    font-size: 33px;
    font-weight: 500;
    color: black;
  }
}
</style>
